/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DTOGetRiskFactorsResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get risk factors for the authenticated user.

Returns:
    DTOGetRiskFactorsResponse with user's risk factors merged with content from Sanity CMS
 * @summary Get Risk Factors
 */
export const getRiskFactorsV1RiskFactorsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<DTOGetRiskFactorsResponse>(
      {url: `/v1/risk-factors`, method: 'GET', signal
    },
      );
    }
  

export const getGetRiskFactorsV1RiskFactorsGetQueryKey = () => {
    return [`/v1/risk-factors`] as const;
    }

    
export const getGetRiskFactorsV1RiskFactorsGetQueryOptions = <TData = Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskFactorsV1RiskFactorsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>> = ({ signal }) => getRiskFactorsV1RiskFactorsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRiskFactorsV1RiskFactorsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>>
export type GetRiskFactorsV1RiskFactorsGetQueryError = unknown


export function useGetRiskFactorsV1RiskFactorsGet<TData = Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskFactorsV1RiskFactorsGet<TData = Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>,
          TError,
          Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRiskFactorsV1RiskFactorsGet<TData = Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Risk Factors
 */

export function useGetRiskFactorsV1RiskFactorsGet<TData = Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskFactorsV1RiskFactorsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRiskFactorsV1RiskFactorsGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



